/**
 * Draft id helpers for scheduled-event note autosave in create mode.
 * Suggestion and manual-create flows use different `draftId` values so an
 * abandoned suggestion note does not recover into an unrelated schedule dialog,
 * while a abandoned manual create can still recover on the next open.
 */

/** Stable draft id for the member-page "Schedule event" create dialog. */
export const MANUAL_SCHEDULED_EVENT_NOTE_DRAFT_ID = 'manual-create';

interface SuggestedScheduledEventDraftSource {
  id?: string;
  callId: number;
  type: string;
}

/**
 * Resolves a stable draft id for a post-call LLM suggested scheduled event.
 * @param suggestedEvent - Suggestion payload from the call drawer.
 * @returns Draft id scoped to that suggestion.
 */
export function resolveSuggestedScheduledEventNoteDraftId(
  suggestedEvent: SuggestedScheduledEventDraftSource
): string {
  if (suggestedEvent.id) {
    return `suggested-${suggestedEvent.id}`;
  }
  return `suggested-call-${suggestedEvent.callId}-${suggestedEvent.type}`;
}
